var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 23,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FDFDFD",
  fillRule: "evenodd",
  d: "M4.413 10.628a2.92 2.92 0 0 0 2.702-2.68L7.992 0l.888 7.947a2.92 2.92 0 0 0 2.705 2.676l4.415.872-4.413.877a2.92 2.92 0 0 0-2.702 2.68L8.008 23l-.888-7.947a2.92 2.92 0 0 0-2.706-2.676L0 11.505z",
  clipRule: "evenodd",
  opacity: 0.8
})));
export { SvgStar as ReactComponent };
export default __webpack_public_path__ + "Star.711a0890.svg";